import { render } from "./QuizHeader.vue?vue&type=template&id=65c00386"
import script from "./QuizHeader.vue?vue&type=script&lang=js"
export * from "./QuizHeader.vue?vue&type=script&lang=js"

import "./QuizHeader.vue?vue&type=style&index=0&id=65c00386&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__